/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCardSkins} from '../api'

 export const useQueryGetCardSkins = createReactQueryHook('getCardSkins', getCardSkins)
